/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __assign, __rest } from "tslib";
import * as React from "react";
import { HTMLSelect } from "@blueprintjs/core";
import { useMonthSelectRightOffset } from "../../common/useMonthSelectRightOffset";
/**
 * Custom react-day-picker dropdown component which implements Blueprint's datepicker design
 * for month and year dropdowns.
 *
 * @see https://daypicker.dev/guides/custom-components
 */
export function DatePicker3Dropdown(_a) {
    var caption = _a.caption, children = _a.children, props = __rest(_a, ["caption", "children"]);
    var containerElement = React.useRef(null);
    var selectElement = React.useRef(null);
    // Use a custom hook to adjust the position of the position of the HTMLSelect icon to appear right next to
    // the month name. N.B. we expect props.caption to be a simple string representing the month name.
    var displayedMonthText = typeof caption === "string" ? caption : "";
    var monthSelectRightOffset = useMonthSelectRightOffset(selectElement, containerElement, displayedMonthText);
    var iconProps = React.useMemo(function () { return (props.name === "months" ? { style: { right: monthSelectRightOffset } } : {}); }, [props.name, monthSelectRightOffset]);
    return (React.createElement("div", { ref: containerElement },
        React.createElement(HTMLSelect, __assign({ iconProps: iconProps, minimal: true, ref: selectElement }, props), children)));
}
//# sourceMappingURL=datePicker3Dropdown.js.map